/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import Checkbox from '../../../juristec-ui/core/Checkbox';
import TextOverflow from '../../../juristec-ui/core/TextOverflow';

import { OrderRow } from './styled/GlobalFilter.styled';

const globalFilterItemDefaultPropHandler = () => { };
const globalFilterItemDefaultPropSelected = [];

const GlobalFilterItem = ({
  option, handler = globalFilterItemDefaultPropHandler, selected = globalFilterItemDefaultPropSelected,
}) => (
  <OrderRow className="hover-bgcolor">
    <Checkbox
      text={(
        <TextOverflow width={200} fontSize={14}>
          {option.label}
        </TextOverflow>
      )}
      variant="outlined"
      style={{ width: '100%', justifyContent: 'flex-start' }}
      checked={selected?.includes(option.value)}
      handleCheckboxChange={(check) => handler(check, option.value)}
    />
  </OrderRow>
);

GlobalFilterItem.propTypes = {
  option: PropTypes.objectOf(PropTypes.any).isRequired,
  handler: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.any),
};

export default GlobalFilterItem;
